import { REQUIRED_PRIVILEGES, PrivilegeService, Privileges } from '@shipit/shared/access-control/util';
import { useMainStore } from '@shipit/shared/app-state/data-access';
import { FeatureName } from '@shipit/shared/feature-flags/util';

const useFeatureAccessValidator = (): { validateAccess: (feature: FeatureName) => boolean } => {
    const { roles, permissions } = useMainStore();

    const validateAccess = (feature: FeatureName): boolean => {
        const requiredPrivileges: Privileges = REQUIRED_PRIVILEGES[feature];

        return PrivilegeService.canAccess(requiredPrivileges, roles.value, permissions.value);
    };

    return {
        validateAccess
    };
};

export { useFeatureAccessValidator };
